<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div v-for="service in items" :key="service.id">
        <div v-if="!service.editing" class="media mt-2 mb-2">
          <img
            v-if="service.image"
            :src="service.image.url"
            style="width: 100px"
            class="mr-3"
          />
          <div class="media-body">
            <p class="text-lg mt-0 offer_name">{{ service.title }}</p>
            <template v-if="service.price_sale">
              <p>
                <span class="cross services__price">€{{ service.price }}</span>
                &nbsp;
                <span class="services__price">€{{ service.price_sale }}</span>
              </p>
            </template>
            <template v-else>
              <p class="services__price">€{{ service.price }}</p>
            </template>
            <p class="offer_text">{{ service.description }}</p>
            <a
              href
              class="btn btn-light btn-sm"
              @click.prevent="edit(service)"
              >{{ $t("Edit") }}</a
            >
            <a
              href
              class="btn btn-danger btn-sm"
              @click.prevent="remove(service)"
              >{{ $t("Delete") }}</a
            >
          </div>
        </div>
        <service-form
          v-if="service.editing"
          :id="service.id"
          :company="model"
          @saved="finishSave(service, true)"
          @cancelled="finishSave(service)"
        />
      </div>
      <br /><button
        v-show="!creating"
        type="button"
        class="btn btn-primary btn-sm mt-3"
        @click="creating = true"
      >
        {{ $t("Add new service") }}
      </button>
      <service-form
        v-if="creating"
        :company="model"
        @saved="finishSave(null, true)"
        @cancelled="finishSave()"
      />
    </template>
  </component>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import InnerItems from "../../../../resources/common/InnerItemsMixin";
import ServiceForm from "./services/Form.vue";

export default {
  name: "FormServicesField",

  components: {
    ServiceForm,
  },

  mixins: [FieldMixin, InnerItems],

  data: function () {
    return {
      resourceBase: `companies/${this.model.id}/services`,
    };
  },
};
</script>
